import { TFunction } from "i18next";
import { FaqItem } from "../../../components/common/BriaFaqSection/faq";

export function getAttributionServiceFaqs(t: TFunction): FaqItem[] {
	return [
		{
			question: t("faq.questions.whenIntegrate.question"),
			answer: [{ type: "text", content: t("faq.questions.whenIntegrate.answer") }],
		},
		{
			question: t("faq.questions.payDataPartners.question"),
			answer: [{ type: "text", content: t("faq.questions.payDataPartners.answer") }],
		},
		{
			question: t("faq.questions.performanceImpact.question"),
			answer: [{ type: "text", content: t("faq.questions.performanceImpact.answer") }],
		},
		{
			question: t("faq.questions.eraseModify.question"),
			answer: [{ type: "text", content: t("faq.questions.eraseModify.answer") }],
		},
		{
			question: t("faq.questions.apiFrequency.question"),
			answer: [{ type: "text", content: t("faq.questions.apiFrequency.answer") }],
		},
		{
			question: t("faq.questions.briaAccess.question"),
			answer: [{ type: "text", content: t("faq.questions.briaAccess.answer") }],
		},
	];
}
